import { requests } from './BaseService'

export type NotificationDefaultsQuery = {
  altId: string
  altType?: string
  channel: string
  notificationType: string
  receiverType?: string
}

export type NotificationDefaultItem = {
  surface: string
  channel: string
  notificationType: string
  receiverType: string
  subject: string
  body: string
  resolvedLocale: string
  usedFallback: boolean
  isDefault: boolean
}

export const EventNotificationService = {
  getEventNotifications: (query: any): Promise<any> =>
    requests().get(`calendars/event-notifications/list`, {
      params: query,
    }),
  getNotificationDefaults: (
    query: NotificationDefaultsQuery
  ): Promise<{ data: { defaults: NotificationDefaultItem[] } }> =>
    requests().get(`calendars/event-notifications/default/notification-configs`, {
      params: query,
    }),
  updateEventNotifications: (payload: any): Promise<any> => {
    return requests().put(`calendars/event-notifications/bulk-update`, payload)
  },
  createEventNotifications: (payload: any): Promise<any> => {
    return requests().post(`calendars/event-notifications`, payload)
  },
}
